import { IApplicationState } from '../../types/redux';
import { IResidentialComplex } from '../../types/residentials';
import { getFilteredResidentialComplexes } from './getFilteredResidentialComplexes';
import { PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE } from '../../settings';

export function getAllocatedResidentialComplexes(state: IApplicationState): IResidentialComplex[] {
  const items = getFilteredResidentialComplexes(state);
  const defaultItems = items.filter(item => item && item.displayType !== 'plus');
  const plusItems = items.filter(item => item && item.displayType === 'plus');
  const shuffledItems: IResidentialComplex[] = [];

  let count = 0;

  for (let i = 0; i < defaultItems.length; i++) {
    if (count === PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE - 1) {
      const item = plusItems.shift();
      if (item) {
        shuffledItems.push(item);
      }
      count = 0;
    }

    shuffledItems.push(defaultItems[i]);
    count++;
  }

  if (plusItems.length) {
    shuffledItems.push(...plusItems);
  }

  return shuffledItems;
}
